<script setup lang="ts">
import { locale } from "../../../../locale";
import { clearChat } from "../../../../states/chatState";
import {
  ClearChatModal,
  closeModal,
} from "../../../../utils/programmingModals";
import BasePopoverItem from "./BasePopoverItem.vue";
const props = defineProps<{
  close: () => void;
}>();
const chatClear = () => {
  ClearChatModal(async () => {
    await clearChat().catch(console.log);
    closeModal();
  });
  props.close();
};
</script>
<template>
  <BasePopoverItem :text="locale.chat.clear" @click.stop="chatClear">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.9582 4.79537L16.1379 2.19762C16.4041 1.88031 16.8772 1.83892 17.1945 2.10518C17.5118 2.37144 17.5532 2.84451 17.2869 3.16182L15.1072 5.75967C16.1298 7.06824 16.1361 8.95683 15.0258 10.2801L14.5236 10.8786L12.3513 17.0324C12.0367 17.9236 11.0372 18.3456 10.2165 17.8769C9.18597 17.2882 7.75336 16.3746 6.26747 15.1278C6.04094 14.9377 5.82225 14.7475 5.6116 14.5584C5.57368 14.5243 5.53992 14.4875 5.51031 14.4485C5.33917 14.2229 5.30696 13.9241 5.41367 13.6672C5.45009 13.5795 5.50268 13.4967 5.57145 13.4234L7.68772 11.1669L5.07782 12.9604L4.97607 13.0303C4.69417 13.224 4.32612 13.2186 4.0577 13.0256C4.01709 12.9964 3.97876 12.9629 3.94336 12.9252C3.88347 12.8613 3.82477 12.7982 3.76727 12.7357C3.42734 12.3664 3.12923 12.0223 2.8749 11.7164C2.27077 10.9896 2.51247 9.93143 3.33545 9.46685L9.01768 6.25919L9.52027 5.6602C10.6307 4.33679 12.4919 4.0151 13.9582 4.79537ZM10.6693 6.6244L10.408 6.93579L13.6155 9.62725L13.8767 9.31587C14.6199 8.43013 14.5044 7.10959 13.6187 6.36637C12.733 5.62314 11.4125 5.73866 10.6693 6.6244ZM7.16208 13.9201L8.78179 12.1931C9.30581 11.6343 9.32465 10.7705 8.82549 10.1894C8.32633 9.60837 7.46955 9.49679 6.83823 9.93062L4.62645 11.4505C4.41489 11.2141 4.22343 10.9914 4.05278 10.7868C4.05767 10.7827 4.06417 10.778 4.0728 10.7731L9.19898 7.87936L12.8964 10.982L10.9369 16.533C10.9336 16.5423 10.9301 16.5496 10.9269 16.5551C9.95638 15.9987 8.61692 15.1411 7.23162 13.9787L7.16208 13.9201Z"
        fill="white"
      />
    </svg>
  </BasePopoverItem>
</template>
